import { actionCreatorFactory } from 'typescript-fsa';
import type { IExposureFilter, ExposureViewMode } from './exposureDashboard.interface';

export namespace ExposureDashboardAction {
  const actionCreator = actionCreatorFactory('ExposureDashboard');

  export const setFilter = actionCreator<IExposureFilter>('SET_FILTER');
  export const setViewMode = actionCreator<ExposureViewMode>('SET_VIEW_MODE');

  export const destroy = actionCreator('DESTROY');
}
